import * as React from "react";
import { connect } from "react-redux";
import { Container, Dropdown, Accordion, Card, Button, Form, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { PartTemplateService } from "../../Common/Services/PartTemplateService";
import paginationFactory from 'react-bootstrap-table2-paginator';
import ProductSlideout from './ProductSlideout';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
// import { SortableContainer, SortableElement,SortableHandle } from "react-sortable-hoc";
import createDOMPurify from "dompurify";
// import { arrayMove } from 'react-sortable-hoc';
import "react-confirm-alert/src/react-confirm-alert.css";
import { SingleSearchDropdownListBootrap } from "../../Common/Components/SingleSearchDropdownListBootrap";
import { faArrowUp, faListSquares } from "@fortawesome/free-solid-svg-icons";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { FaArrowUpFromBracket, FaCirclePlus, FaEllipsis, FaCircleMinus } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import "../../Modules/customer.scss";
import { DocumentService } from "../../Common/Services/DocumentService";
import { TransactionService } from "../../Common/Services/TransactionService";
class BucketMaster extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            coaList: [],
            htmlItem: [],
            htmlErrorItem: [],
            htmlWarningItem: [],
            searcResult: [],
            productid: 0,
            isSaveOpen: false,
            loading: false,
            isWait: false,
            formData: { processlist: [], },
        };


    }



    componentDidMount() {
        this.GetPayrollCOA({});
    }




    updateState = (e: any, index: any, type: any, txtID) => {
        if (this != undefined) {
            let isStateChanged = true;
            let isSaveOpen = true;
            let start = e.target?.selectionStart;
            let end = e.target?.selectionEnd;
            let searcResult = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.searcResult))
            );


            if (type === "name") {

                e.preventDefault();

                searcResult[index].name = e.target.value;

                this.setState({ searcResult, isStateChanged, isSaveOpen }, () => {
                    $("input[id^='txtname" + txtID + "txt']").focus();

                    let txtdesc = $("input[id^='txtname" + txtID + "txt']")[0] as any;
                    if (txtdesc !== null && txtdesc !== undefined) {
                        txtdesc.selectionStart = start;
                        txtdesc.selectionEnd = end;
                    }
                });
            }
            if (type === "identifier") {
                e.preventDefault();
                e.target.value = e.target.value.replace(/[^A-Za-z]/g, "");
                searcResult[index].identifier = e.target.value;

                this.setState({ searcResult, isStateChanged, isSaveOpen }, () => {
                    $("input[id^='txtidentifier" + txtID + "txt']").focus();
                    let txtdesc = $("input[id^='txtidentifier" + txtID + "txt']")[0] as any;
                    if (txtdesc !== null && txtdesc !== undefined) {
                        txtdesc.selectionStart = start;
                        txtdesc.selectionEnd = end;
                    }
                });
            }

            if (type === "active") {
                e.preventDefault();

                if (e.target.checked) {

                    // $("input[id^='txtstatus" + txtID + "txt']").isChecked =true;
                    searcResult[index].active = 1;
                }
                else {
                    searcResult[index].active = 0;
                }
                this.setState({ searcResult, isStateChanged, isSaveOpen }, () => {


                });
            }

            if (type === "controlled") {
                e.preventDefault();

                if (e.target.checked) {

                    // $("input[id^='txtstatus" + txtID + "txt']").isChecked =true;
                    searcResult[index].controlled = 1;
                }
                else {
                    searcResult[index].controlled = 0;
                }
                this.setState({ searcResult, isStateChanged, isSaveOpen }, () => {


                });
            }

        }
    };




    GetPayrollCOA = (requestlist: any) => {


        TransactionService.GetPayrollCOA(requestlist)
            .then(async (result: any[] | null) => {

                if (result != null) {

                     result.forEach(element => {
                        let item: any = {};
                        item.id = element.accountID;
                        item.name = element.accountName + "-" + element.accountCode;
                        this.state.coaList.push(item);
                        }); 

                    this.setState({ isWait: false, isStateChanged: false, isSaveOpen: false },()=>{
                                this.GetBucketMaster({});
                    });
                }
                resolve();
            })
            .catch((err: any) => {
                toast.error(`Server Error, ${err}`);
                this.setState({ isWait: false });
                reject();
            });
    };

   GetBucketMaster = (requestlist: any) => {
    const { coaList } = this.state;

    const coaMap = new Map(
        (coaList || []).map((x: any) => [x.id, x.name])
    );

    TransactionService.GetBucketMaster(requestlist)
        .then((result: any[] | null) => {

            if (!result || result.length === 0) {
                this.setState({
                    searcResult: [],
                    isWait: false,
                    isStateChanged: false,
                    isSaveOpen: false
                });
                return;
            }

            const updatedResult = result.map((item: any) => ({
                ...item,
                name: coaMap.get(item.accountId) ?? ""
            }));

            this.setState({
                searcResult: updatedResult,
                isWait: false,
                isStateChanged: false,
                isSaveOpen: false
            });
        })
        .catch((err: any) => {
            toast.error(`Server Error, ${err}`);
            this.setState({ isWait: false });
        });
};


    discard = () => {
        let requestlist = { ...this.state.requestlist };
        // this. GetPayrollCOA(requestlist);
        this.setState({ isSaveOpen: false }, () => {
        // this.GetBucketMaster(requestlist);

        });
    };

    saveApi = () => {
        let { searcResult } = this.state;

        this.setState({ isWait: true });
       
            TransactionService.SaveBucketCOA(searcResult).then(
                async (result: any | null) => {

                    let requestlist = { ...this.state.requestlist };
                    // this.GetBucketMaster(requestlist);

                    toast.success("COA Mapped",
                        { position: toast.POSITION.BOTTOM_RIGHT, containerId: "userManagementHierarchy" });

                    this.setState({ isSaveOpen: false, loading: false,isWait:false });
                }
            );
        };

    handleSelectedItem = (control: any, id: any) => {
    let controlID = Number(control.split('_')[0]);
    if (controlID === 1) {
     
      let rowIndex = Number(control.split('_')[1]);
      let filterRow = this.state.coaList.filter(x => x.id === id);

       

      this.state.searcResult[rowIndex].accountId = filterRow[0].id;
      this.state.searcResult[rowIndex].name = filterRow[0].name;

      this.setState({isStateChanged:true,isSaveOpen:true});
    }
   
  };

    render() {
        const { permissions } = this.props;
        // const hasAddPermission = permissions && permissions['Document Master'] ? permissions['Document Master'].includes('Add Category') : false;
        // const hasEditPermission = permissions && permissions['Document Master'] ? permissions['Document Master'].includes('Edit Category') : false;

        const hasAddPermission = true;
        const hasEditPermission = true;


        const templateColumns = [

            {
                dataField: 'srno',
                text: 'Sr No.',
                headerStyle: { width: '10%' },
                formatter: (cell: any, row: any, rowIndex: any) => {

                    return (
                        <div>
                            {rowIndex + 1}
                        </div>
                    );
                },
            },

            {
                dataField: 'description',
                text: 'Bucket Name',
                headerStyle: { width: '30%' },
                hidden: false,
                editable: false,
            },
             {
                 dataField: 'userName',
                 text: 'Assigned Operator',
                 headerStyle: { width: '26%' },
                 hidden: false,
                 editable: false,
                 headerAttrs: (column, colIndex) => (
                   { 'tabIndex': '-1' }
                 ),
                 formatter: (cell: any, row: any, rowIndex: any) => {
                   let id = "txtUser" + rowIndex + "txt";
                   let disable = false;
                   return (
                     <div>
                      
                       <SingleSearchDropdownListBootrap
                         tabIndex={this.state.tabEnable}
                         itemList={this.state.coaList}
                         handleSelectedItem={this.handleSelectedItem.bind(row, 1 + '_' + rowIndex)}
                         defaultItem={row.name}
                         defaultText={"Search COA"}
                         defaultName={row.name}
                         controlID="1"
                         id={"ddlUser-" + rowIndex + "ddl"}
                       //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}
                       // disabled={disable}
                       />
                     </div>
                   );
           
           
           
                 },
           
               },
                {
                dataField: 'srno',
                text: '',
                headerStyle: { width: '50%' },
                
            },

            {
                dataField: 'controlled',
                text: 'Controlled',
                headerStyle: { width: '80px' },
                hidden: true,
                headerClasses: 'text-center',
                classes: 'text-center',

                editable: false,
                headerAttrs: (column, colIndex) => (
                    { 'tabIndex': '-1' }
                ),
                formatter: (cell: any, row: any, rowIndex: any) => {
                    let id = "txtcontrolled" + rowIndex + "txt";
                    let disable = false;
                    return (
                        <div>
                            <Form.Check
                                className="knob"
                                // tabIndex={this.state.tabEnable}
                                id={"txtcontrolled" + rowIndex + "txt"}
                                type="switch"
                                checked={row.controlled}
                                // placeholder="Enter Part No"
                                //value={value.pDescription}
                                onChange={(e) => this.updateState(e, rowIndex, "controlled", rowIndex)}
                                autoComplete="off"
                                disabled={row.id > 0 || (row.id > 0 && !hasEditPermission)}
                                title=""
                            //maxLength={500}
                            />

                        </div>

                    );



                },

            },
            {
                dataField: 'active',
                text: 'Active',
                headerClasses: 'text-center',
                classes: 'text-center',

                headerStyle: { width: '80px' },
                hidden: true,
                editable: false,
                headerAttrs: (column, colIndex) => (
                    { 'tabIndex': '-1' }
                ),
                formatter: (cell: any, row: any, rowIndex: any) => {
                    let id = "txtdescription" + rowIndex + "txt";
                    let disable = false;
                    return (
                        <div>
                            <Form.Check
                                className="knob"
                                // tabIndex={this.state.tabEnable}
                                id={"txtactive" + rowIndex + "txt"}
                                type="switch"
                                checked={row.active}
                                // placeholder="Enter Part No"
                                //value={value.pDescription}
                                onChange={(e) => this.updateState(e, rowIndex, "active", rowIndex)}
                                autoComplete="off"
                                disabled={row.isLocked || (row.id > 0 && !hasEditPermission)}
                                title=""
                            //maxLength={500}
                            />

                        </div>

                    );



                },

            }


        ];

        const customTotal = (from, to, size) => (
            <span className="text-muted">
                Showing {from} to {to} of {size} entries
            </span>
        );
        const options = {

            showTotal: true,
            hideSizePerPage: false,
            hidePageListOnlyOnePage: true,
            paginationTotalRenderer: customTotal,
            disablePageTitle: true,
            sizePerPageList: [{
                text: '10', value: 10
            },
            {
                text: '25', value: 25
            },
            {
                text: '50', value: 50
            },

            {
                text: 'All', value: this.state.searcResult.length
            }] // A numeric array is also available. the purpose of above example is custom the text
        };
        let confirmModalContent = [
            {
                title: "Delete Row",
                desc: "Are you sure you want to delete?",
                cancleAction: "Cancel",
                ActionTrue: "Delete",
            },
        ];
        const {

            showSlideout,

        } = this.state;


        let { searcResult, isSaveOpen, loading, isWait, d } = this.state;


        return (


            <>
                <React.Fragment>



                    <Container fluid className="body-sec">
                        <div className="page-heading underline d-flex">

                            Bucket Master
                            <div className="action-group d-flex flex-row ml-auto">
                            </div>
                        </div>
                        <ToastContainer
                            enableMultiContainer
                            autoClose={3000}
                            containerId={"userManagementHierarchy"}
                        />

                  
                        {this.state.searcResult.length > 0 && (
                            <div className="table-responsive1" >
                                <section className="pb-3">
                                    <div
                                        className="table table-borderless align-middle transactions-list"

                                    >
                                        <BootstrapTable
                                            id="tbltemplate2"
                                            keyField="id"
                                            data={this.state.searcResult}
                                            columns={templateColumns}
                                        // pagination={paginationFactory(options)}
                                        />
                                    </div>
                                </section>
                            </div>

                        )}




                        <div className="filter-sec height-172">

                            <br></br>
                            <br></br>

                        </div>
                        <div className="d-flex align-items-center justify-content-end height-20"

                        >
                            {isSaveOpen && (
                                <div className="TabFooter-Pay"
                                    style={{ minWidth: "83.7%", width: "992px", maxWidth: "100%" }}
                                >
                                    <div className="bulkSelectFooter">
                                        <div className="mr-auto message">
                                            <span>You have unsaved changes</span>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={this.discard}
                                            className="btn btn-primary btn-discard"
                                        >
                                            Discard
                                        </button>
                                        {(hasEditPermission || hasAddPermission) &&
                                            <button
                                                type="button"
                                                disabled={isWait}
                                                onClick={this.saveApi}
                                                className="btn btn-primary"
                                            >
                                                {isWait ? "Loading..." : "Save Changes"}
                                            </button>}
                                    </div>
                                </div>
                            )}
                        </div>


                    </Container>

                    {(this.state.isSpinner || this.state.isSaveSpinner) && (
                        <div className="loader-spinner d-flex justify-content-center align-items-center">
                            <Spinner animation="border" variant="success" />
                        </div>
                    )}

                </React.Fragment>
            </>
        );
    }

}

const mapStateToProps = (state) => ({
    permissions: state.PagePermissionReducer.permissions,
    locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(BucketMaster);